import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, ArrowUpRight } from 'lucide-react';
export const ServicesSection = () => {
  const [hoveredService, setHoveredService] = useState(null);
  const verandaServices = [{
    id: 'veranda-poly',
    title: 'Veranda Polycarbonaat',
    description: 'Lichtgewicht, voordelig en UV-bestendig. Ideaal voor een praktische en betaalbare oplossing.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kiDtckW7d51UoZiKrqj89j/Afbeelding_van_WhatsApp_op_2025-04-23_om_16.02.16_5dcc6d81.jpg'
  }, {
    id: 'veranda-glas',
    title: 'Veranda Glas',
    description: 'Maximale lichtinval en een elegante uitstraling. Perfect voor een stijlvolle, transparante overkapping.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6hFDuMkKtrrN66CxmjRtGR/488225866_17848235589441316_3303414385176099418_n.jpg'
  }, {
    id: 'overkappingen',
    title: 'Overkappingen',
    description: 'Creëer een beschutte buitenruimte met onze duurzame overkappingen voor terrassen en tuinen.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/31qoFLD89xVNfcg4Xki5Xk/491436229_17850212535441316_3063343797506131228_n.jpg'
  }, {
    id: 'schuifwanden',
    title: 'Schuifwanden',
    description: 'Bescherm uw veranda tegen wind en regen zonder het uitzicht te belemmeren met onze glazen schuifwanden.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qdZM8nivB1Yyk7qr3hip3K/Glazen-schuifwand-3.webp'
  }, {
    id: 'schuifdeuren',
    title: 'Schuifdeuren',
    description: 'Creëer een naadloze overgang tussen binnen en buiten met onze hoogwaardige schuifdeursystemen.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vffEbyujZ16QzAiNyeYAva/MB_Veranda_Deventer_social_content_092-scaled-545x409x0x0x545x409x1733397477.webp'
  }, {
    id: 'aluminium',
    title: 'Aluminium',
    description: 'Duurzame, onderhoudsarme aluminium constructies voor verschillende toepassingen in uw buitenruimte.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/67a8pJg9TPo8M3eTLZxSWV/Afbeelding_van_WhatsApp_op_2025-04-23_om_16.02.17_55a02d27.jpg'
  }, {
    id: 'rolling-roof',
    title: 'Rolling Roof Systems',
    description: 'Geniet van een flexibel daksysteem dat u kunt openen en sluiten wanneer u maar wilt.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c5PgifDabQSNHLLuTsSwGk/Afbeelding_van_WhatsApp_op_2025-05-13_om_12.42.34_8f7930e9.jpg'
  }, {
    id: 'carport',
    title: 'Carport',
    description: 'Bescherm uw auto tegen weersinvloeden met een stijlvolle en duurzame carport op maat.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7nk9VQSmML7hwtXboprLaz/IMG-20250423-WA0012.jpg'
  }];
  const overigeServices = [{
    id: 'tuinbestrating',
    title: 'Tuin Bestratingen',
    description: 'Complementeer uw buitenruimte met professionele bestrating voor een complete en afgewerkte tuin.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sQdRcEfDg3cmH2XT3UqKCc/Afbeelding_van_WhatsApp_op_2025-05-13_om_11.54.19_fa7eea2b.jpg'
  }, {
    id: 'schuttingen',
    title: 'Hout/Beton Schuttingen',
    description: 'Creëer privacy en beschutting in uw tuin met onze schuttingen van hout of beton.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xxPuNDsXGaUcEKqqdjT9ZN/Afbeelding_van_WhatsApp_op_2025-05-13_om_11.54.17_d6a24884.jpg'
  }, {
    id: 'zandcement',
    title: 'Zandcement Vloeren',
    description: 'Een solide basis voor uw veranda of overkapping met onze professioneel aangelegde zandcement vloeren.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6csxjgvfwC84VMs7DY8i12/IMG-20250423-WA0009.jpg'
  }];
  return <section className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-1518">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMzMjMyMzIiIGZpbGwtb3BhY2l0eT0iMC4wMiI+PHBhdGggZD0iTTM2IDM0aDR2MWgtNHYtMXptMC0yaDF2NGgtMXYtNHptMi0yaDF2MWgtMXYtMXptLTIgMmgtMXYtMWgxdjF6bS0yLTJoMXYxaC0xdi0xem0yLTJoMXYxaC0xdi0xem0tMiAydi0xaDF2MWgtMXptLTIgMGgtMXYtMWgxdjF6bS0yIDBoLTF2LTFoMXYxem0wIDJoLTF2LTFoMXYxem0wIDJoLTF2LTFoMXYxem0yIDBoMXYxaC0xdi0xem0yIDBoMXYxaC0xdi0xem0yIDBoMXYxaC0xdi0xeiIvPjwvZz48L2c+PC9zdmc+')] opacity-20" data-id="element-1519"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-1520">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1521">
          <div className="inline-flex items-center gap-3 mb-4 justify-center" data-id="element-1522">
            <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-1523"></div>
            <span className="text-sm font-medium text-[#B89429] uppercase tracking-wider" data-id="element-1524">
              Onze diensten
            </span>
            <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-1525"></div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-1526">
            Ontdek wat wij voor u kunnen betekenen
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1527">
            Van veranda's en overkappingen tot tuinbestrating – wij bieden
            complete oplossingen voor uw buitenruimte.
          </p>
        </div>
        {/* Veranda Services Section */}
        <div className="mb-20" data-id="element-1528">
          <div className="flex items-center mb-10" data-id="element-1529">
            <div className="w-12 h-[2px] bg-[#CDA735] mr-4" data-id="element-1530"></div>
            <h3 className="text-2xl font-bold text-gray-800" data-id="element-1531">
              Veranda's & Overkappingen
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1532">
            {verandaServices.map(service => <div key={service.id} className="group relative bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300" onMouseEnter={() => setHoveredService(service.id)} onMouseLeave={() => setHoveredService(null)} data-id="element-1533">
                {/* Service image */}
                <div className="relative h-48 overflow-hidden" data-id="element-1534">
                  <img src={service.image} alt={`${service.title} - ${service.description.substring(0, 50)}...`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1535" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-80" data-id="element-1536"></div>
                  {/* Title overlay on image */}
                  <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-1537">
                    <h4 className="text-lg font-semibold text-white group-hover:text-[#CDA735] transition-colors duration-300" data-id="element-1538">
                      {service.title}
                    </h4>
                  </div>
                </div>
                {/* Service content */}
                <div className="p-4 relative" data-id="element-1539">
                  <p className="text-gray-600 text-sm mb-6" data-id="element-1540">
                    {service.description}
                  </p>
                  {/* CTA button that appears on hover */}
                  <Link to="/offerte-aanvragen" className={`absolute bottom-4 right-4 inline-flex items-center justify-center text-sm font-medium rounded-md transition-all duration-300 ${hoveredService === service.id ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-2'}`} data-id="element-1541">
                    <span className="text-[#CDA735] hover:text-[#B89429] flex items-center" data-id="element-1542">
                      Offerte aanvragen
                      <ArrowUpRight className="ml-1 h-4 w-4" data-id="element-1543" />
                    </span>
                  </Link>
                </div>
              </div>)}
          </div>
        </div>
        {/* Overige Diensten Section */}
        <div data-id="element-1544">
          <div className="flex items-center mb-10" data-id="element-1545">
            <div className="w-12 h-[2px] bg-[#CDA735] mr-4" data-id="element-1546"></div>
            <h3 className="text-2xl font-bold text-gray-800" data-id="element-1547">
              Overige Diensten
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1548">
            {overigeServices.map(service => <div key={service.id} className="group relative bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col" onMouseEnter={() => setHoveredService(service.id)} onMouseLeave={() => setHoveredService(null)} data-id="element-1549">
                {/* Service image */}
                <div className="relative h-48 overflow-hidden" data-id="element-1550">
                  <img src={service.image} alt={`${service.title} - ${service.description.substring(0, 50)}...`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1551" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-80" data-id="element-1552"></div>
                  {/* Title overlay on image */}
                  <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-1553">
                    <h4 className="text-lg font-semibold text-white group-hover:text-[#CDA735] transition-colors duration-300" data-id="element-1554">
                      {service.title}
                    </h4>
                  </div>
                </div>
                {/* Service content */}
                <div className="p-4 flex-grow relative" data-id="element-1555">
                  <p className="text-gray-600 text-sm mb-6" data-id="element-1556">
                    {service.description}
                  </p>
                  {/* CTA button that appears on hover */}
                  <Link to="/offerte-aanvragen" className={`absolute bottom-4 right-4 inline-flex items-center justify-center text-sm font-medium rounded-md transition-all duration-300 ${hoveredService === service.id ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-2'}`} data-id="element-1557">
                    <span className="text-[#CDA735] hover:text-[#B89429] flex items-center" data-id="element-1558">
                      Offerte aanvragen
                      <ArrowUpRight className="ml-1 h-4 w-4" data-id="element-1559" />
                    </span>
                  </Link>
                </div>
              </div>)}
          </div>
        </div>
        {/* Bottom CTA */}
        <div className="mt-20 text-center bg-white p-8 rounded-lg shadow-sm border border-gray-100" data-id="element-1560">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-1561">
            Klaar om uw project te starten?
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto" data-id="element-1562">
            Onze experts staan klaar om u te helpen bij het realiseren van uw
            droomproject. Vraag vrijblijvend een offerte aan of neem contact met
            ons op voor meer informatie.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1563">
            <Link to="/offerte-aanvragen" className="inline-flex items-center justify-center bg-[#CDA735] hover:bg-[#B89429] text-white font-medium px-8 py-3 rounded-md shadow-sm transition-all" data-id="element-1564">
              <span data-id="element-1565">Offerte aanvragen</span>
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-1566" />
            </Link>
            <Link to="/contact" className="inline-flex items-center justify-center bg-white hover:bg-gray-50 text-[#B89429] border border-[#CDA735]/30 hover:border-[#CDA735] font-medium px-8 py-3 rounded-md shadow-sm transition-all" data-id="element-1567">
              <span data-id="element-1568">Neem contact op</span>
            </Link>
          </div>
        </div>
      </div>
    </section>;
};